import type { LngLat, LngLatBounds } from "ymaps3"
import type { SearchEventDto } from "@app/data/tribeSwaggerApi"

/**
 * Память карты на время сессии. Карта пересоздаётся при каждом открытии страницы,
 * поэтому без этой памяти возврат со страницы события снова «летел» к центру города
 * и заново грузил события. Теперь карта открывается там же и с теми же событиями.
 */
export const mapCache: {
  view?: { center: LngLat; zoom: number; bounds?: LngLatBounds }
  cityKey?: string          // для какого города сохранён вид
  events?: SearchEventDto[]
  dataKey?: string          // для каких фильтров и города загружены события
  savedAt?: number
} = {}

// Сколько считать события свежими при возврате на карту
export const MAP_CACHE_TTL_MS = 10 * 60 * 1000

export const isFresh = () => !!mapCache.savedAt && Date.now() - mapCache.savedAt < MAP_CACHE_TTL_MS
